import {
  Divider,
  Flex,
  Popover,
  ScrollArea,
  ScrollAreaAutosize,
} from "@mantine/core";
import { BoxTitle, Container, LastUpdate } from "./StyledComponents";
import styled from "styled-components";
import { theme } from "../../theme";
import { UsersIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { getLiveTodayShifts } from "../../api/dashboardApi";
import { useFilterContext } from "../../context/DashboardFilterContext";
import dayjs from "dayjs";

const TodayShifts = ({ flex }: { flex: any }) => {
  const { filters } = useFilterContext();
  const [todayShifts, setTodayShifts] = useState<any>();
  const [totalEmployee, setTotalEmployee] = useState<any>();
  const [activeEmployee, setActiveEmployee] = useState<any>();

  const status = [
    {
      color: theme.colors.alert.green,
      background: "#ECFDF3",
      text: "Aktif",
    },
    {
      color: theme.colors.alert.orange,
      background: "#FFFAEB",
      text: "Başlayacak",
    },
    {
      color: theme.colors.alert.red,
      background: "#FEF3F2",
      text: "Sona Erdi",
    },
  ];

  const getTodayShifts = async () => {
    try {
      const response = await getLiveTodayShifts(filters);
      setTodayShifts(response?.data?.shifts);
      setTotalEmployee(response?.data?.total);
      setActiveEmployee(response?.data?.active);
    } catch (error) {}
  };

  useEffect(() => {
    getTodayShifts();
  }, [filters]);

  return (
    <Container $flex={flex}>
      <Flex justify={"space-between"} align={"center"}>
        <BoxTitle>Bugünün Vardiyaları</BoxTitle>
        <Flex gap={20}>
          <CountBox $color={theme.colors.brand.normal}>
            <span>{totalEmployee}</span>
            <div>Toplam Çalışan</div>
          </CountBox>
          <CountBox $color={theme.colors.alert.green}>
            <span>{activeEmployee}</span>
            <div>Aktif</div>
          </CountBox>
        </Flex>
      </Flex>
      <ScrollAreaAutosize mih={204} mah={204}>
        <Flex gap={12} direction={"column"} style={{ overflow: "hidden" }}>
          {todayShifts?.map((shift: any) => (
            <ShiftWrapper>
              <Flex align={"center"} gap={8} flex={2}>
                <Flex gap={4} direction={"column"}>
                  <ShiftTitle>{shift?.department}</ShiftTitle>
                  <ShiftTime>
                    {dayjs(shift?.startTime).format("HH:mm")} -{" "}
                    {dayjs(shift?.endTime).format("HH:mm")}
                  </ShiftTime>
                </Flex>
              </Flex>
              <Flex flex={1} justify={"space-between"}>
                <Popover
                  disabled={shift?.employees?.length === 0}
                  withArrow
                  position="left"
                >
                  <Popover.Target>
                    <Flex
                      style={{
                        cursor: "pointer",
                      }}
                      align={"center"}
                      gap={8}
                    >
                      <UsersIcon
                        color={theme.colors.greyscale.black}
                        height={20}
                      />
                      <EmployeeCount>
                        {shift?.department == "Genel"
                          ? "Herkes"
                          : `${shift?.count} Kişi`}
                      </EmployeeCount>
                    </Flex>
                  </Popover.Target>
                  <Popover.Dropdown>
                    <ScrollAreaAutosize h={150} mih={"max-content"}>
                      <Flex direction={"column"} gap={15}>
                        {shift?.employees?.map((employee: any, index: any) => (
                          <>
                            <Flex direction={"column"}>
                              <div
                                style={{
                                  fontWeight: "600",
                                }}
                              >
                                {employee?.name}
                              </div>
                              <div
                                style={{
                                  fontSize: "14px",
                                }}
                              >
                                {employee?.role}
                              </div>
                            </Flex>
                            {shift?.employees?.length - 1 !== index && (
                              <Divider />
                            )}
                          </>
                        ))}
                      </Flex>
                    </ScrollAreaAutosize>
                  </Popover.Dropdown>
                </Popover>
                <Flex align={"center"}>
                  <StatusBadge
                    $color={status[shift?.status]?.color}
                    $bg={status[shift?.status]?.background}
                  >
                    {status[shift?.status]?.text}
                  </StatusBadge>
                </Flex>
              </Flex>
            </ShiftWrapper>
          ))}
        </Flex>
      </ScrollAreaAutosize>
    </Container>
  );
};

export default TodayShifts;

const ShiftWrapper = styled.div`
  display: flex;
  border: 1px solid ${theme.colors.greyscale.gray20};
  border-radius: 6px;
  height: 60px;
  padding: 8px;
  justify-content: space-between;
`;

const Box = styled.div<{ $bg: string; $color: string }>`
  display: flex;
  flex: 1;
  gap: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  .count {
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
  }
  .text {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 44px;
  border-radius: 6.6px;
  background: ${theme.colors.secondary.blue.light};
`;

const ShiftTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.greyscale.black};
`;

const ShiftTime = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.greyscale.gray80};
`;

const EmployeeCount = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.greyscale.black};
`;

const StatusBadge = styled.div<{ $color: any; $bg: any }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  border-radius: 50px;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
  height: 32px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`;

const CountBox = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: ${({ $color }) => $color};
  }
  div {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${theme.colors.greyscale.gray80};
  }
`;
